/**
 * Modelo compartido de los módulos multimodales (Terrestrial / Ocean / Air).
 *
 * La idea: un solo listado configurable en vez de tres módulos copiados. Cada
 * modalidad aporta su catálogo de estatus y sus columnas, pero el comportamiento
 * (buscador, filtros, status cards, paginación) es el mismo que en Loads.
 */

export type ShipmentMode = 'land' | 'ocean' | 'air';

/** Etapa normalizada, común a las 3 modalidades. */
export type ShipmentStage =
  | 'origin'
  | 'in_transit'
  | 'destination'
  | 'delivered'
  | 'cancelled'
  | 'unknown';

/**
 * Fila del listado.
 *
 * Los campos propios de cada modalidad son opcionales: marítimo llena
 * contenedor/BL/buque, aéreo llena AWB/vuelos, terrestre llena carrier/trailer.
 */
export interface ShipmentRow {
  id: string;
  /** Folio interno de Dylo (identificador principal para el usuario). */
  dyloId: string;
  mode: ShipmentMode;

  /** Nombre del estatus tal como lo define el catálogo de su modalidad. */
  status: string;
  stage: ShipmentStage;

  client?: string;
  /** Naviera, aerolínea o transportista. */
  carrier?: string;
  origin?: string;
  destination?: string;

  /** Referencia del transportista visible en la tabla. */
  reference?: string;

  etd?: string | null;
  eta?: string | null;

  /* --- Marítimo --- */
  containerNumber?: string;
  blNumber?: string;
  vessel?: string;

  /* --- Aéreo --- */
  awbNumber?: string;
  flights?: string[];
  pieces?: number;
  weight?: string;

  /* --- Terrestre --- */
  proNumber?: string;
  trailer?: string;

  createdAt?: string | null;
  /** % de avance estimado por tiempo (no es posición real). */
  progress?: number | null;
}

export const MODE_LABELS: Record<ShipmentMode, string> = {
  land: 'Terrestrial',
  ocean: 'Ocean',
  air: 'Air',
};

export const STAGE_LABELS: Record<ShipmentStage, string> = {
  origin: 'At origin',
  in_transit: 'In transit',
  destination: 'At destination',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  unknown: 'Unknown',
};
